import { createSlice } from "@reduxjs/toolkit";
import { cancelBookingByDates, saveBooking, validateBookingByDate } from "./bookingThunks";
import i18n from "../../i18n";

interface BookingState {
  loading: boolean;
  success: boolean;
  error: string | null;
  lastResponse: any | null;
}

const initialState: BookingState = {
  loading: false,
  success: false,
  error: null,
  lastResponse: null,
};

const bookingSlice = createSlice({
  name: "booking",
  initialState,
  reducers: {
    resetBookingState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.lastResponse = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(saveBooking.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(saveBooking.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.lastResponse = action.payload;
      })
      .addCase(saveBooking.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = (action.payload as string) ?? i18n.t("system.unknownError");
      })
      .addCase(validateBookingByDate.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(validateBookingByDate.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.lastResponse = action.payload;
      })
      .addCase(validateBookingByDate.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = (action.payload as string) ?? i18n.t("system.unknownError");
      })
      .addCase(cancelBookingByDates.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(cancelBookingByDates.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.lastResponse = action.payload;
      })
      .addCase(cancelBookingByDates.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = (action.payload as string) ?? i18n.t("system.unknownError");
      });
  },
});

export const { resetBookingState } = bookingSlice.actions;
export default bookingSlice.reducer;
